<template>
    <div>
        <div class="col-sm-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                        >{{ $t('landingPage.settingApplicationRule.titleBlock') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="ruleForm.title_block"
                            :config.sync="configForm.configFieldTitle"
                            @blur="handleValidateField(configForm.configFieldTitle)"
                        />
                        <div class="mt-3">
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                                <div class="col-sm-3">
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        <InputText
                                            style="max-width: 120px"
                                            :model.sync="ruleForm.size_title"
                                            :config.sync="configForm.configFieldSizeTitle"
                                        />
                                        <span>px</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="ruleForm.color_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="ruleForm.color_title"
                                            :config="{
                                                error: false
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="ruleForm.background_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="ruleForm.background_title"
                                            :config="{
                                                error: false
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationRule.background') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="ruleForm.background_image"
                            :id="`BackgroundImgLPApplicationRule`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                        <div class="form-group row mt-2">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="ruleForm.background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="ruleForm.background_color"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <InputCheckBox
                                :model.sync="ruleForm.is_repeat"
                                :id="`check-repeat-background-app_rule`"
                                :value="ruleForm.is_repeat"
                                :label="`repeat`"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.style') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap" style="gap: 1rem">
                            <div v-for="item in LIST_STYLE_APPLICATION_RULE" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="ruleForm.style"
                                    :name="`application-application_rule-style`"
                                    :id="`application-application_rule-style-${item.id}`"
                                    :value="item"
                                    :label="item.name"
                                    @change="handleShotCodeStyle('select')"
                                />
                                <div class="mt-2" style="width: 100px; height: 80px">
                                    <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationRule.detail') }} </label>
                    <div class="col-sm-10">
                        <Editor
                            v-if="isVisibleEditor"
                            :id="`editorStyleApplicationRule`"
                            :isBackgroundImageEditor="false"
                            :model.sync="ruleForm.html_content"
                            :modelEvents="`change keydown blur focus paste`"
                            :configInit="configEditor"
                            @init="onEditorInit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { LIST_STYLE_APPLICATION_RULE } from '../../styles';
import { onHandleChangeTemp, mapImageDefault } from '../../handlers';
import { cloneDeep } from 'lodash';

import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'SettingApplicationRule',
    components: {
        InputText,
        UploadImageCommon,
        InputCheckBox,
        Editor,
        InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage'])
        })
    },

    data() {
        return {
            ruleForm: cloneDeep(this.dataForm),
            objEditor: null,
            isVisibleEditor: false,
            configEditor: {
                height: 600,
                content_style: ''
            },
            LIST_STYLE_APPLICATION_RULE: mapImageDefault(LIST_STYLE_APPLICATION_RULE)
        };
    },

    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        },

        onHandleTimeOutCssEditor(timer = 500) {
            setTimeout(() => {
                let { style } = this.ruleForm;
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
            }, timer);
        },

        handleShotCodeStyle(type = null) {
            let { style } = this.ruleForm;
            if (!style) return;
            if (type === 'select') {
                this.ruleForm.background_color = style.backgroundColorDefault ?? '#ffffff';
                this.ruleForm.html_content = '';
                this.objEditor.setContent('');
            }
        },

        updateEditorStyle(editor, newCss) {
            const head = editor?.contentDocument?.head || editor?.getDoc().head;
            if (!head) return;
            let styleTag = head.querySelector('#dynamic-editor-style');
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = 'dynamic-editor-style';
                head.appendChild(styleTag);
            }
            styleTag.innerHTML = newCss;
        }
    },
    watch: {
        infoSettingLandingPage: {
            handler: function (newSetting) {
                if (this.ruleForm.style) return;
                let checkTem = onHandleChangeTemp(newSetting, this.ruleForm, this.LIST_STYLE_APPLICATION_RULE);
                if (checkTem && this.objEditor) this.handleShotCodeStyle('select');
            },
            immediate: true,
            deep: true
        },

        ruleForm: {
            handler: function (newRuleForm) {
                this.$emit('update:dataForm', newRuleForm);
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        setTimeout(() => {
            this.isVisibleEditor = true;
        }, 300);
        this.onHandleTimeOutCssEditor(2000);
    }
};
</script>

<style lang="scss" scoped></style>
